import React, { useState, useEffect } from 'react';
import api from './Services';
import SelectVegetables from './Components/SelectVegetables';
import SelectYear from './Components/SelectYear';
import { CircleX } from 'lucide-react';


function Log(props) {
  const thisYear = new Date().getFullYear()
  const [yearArr, setYearArr] = useState([thisYear.toString()]);
 //Add isLoading state for arrays
  const [calendarEntries, setCalendarEntries] = useState({entries:[], total: 0, total_this_page: 0, max_num_pages: 0, isLoading: false});
  const [generalEntries, setGeneralEntries] = useState({data: [], isLoading: false});
  const [sowingDates, setSowingDates] = useState({data: [], isLoading: false});
  const [selectedYear, setSelectedYear] = useState(thisYear.toString())
  const [selectedVegetableID, setSelectedVegetableID] = useState(0)
  const [nextSowingDate, setNextSowingDate] = useState(new Date());
  //const [searchData, setSearchData] = useState('');
  const [filterHasCleared, setFilterHasCleared] = useState(true);



  /*====================== 
  FETCH DATA
  ============================*/



  useEffect(() => {
    fetchVegetableEntries()
 }, [selectedYear, selectedVegetableID]);
  
   // Fetch Calendar Vegetable Entries 

  const fetchVegetableEntries = async () => {
    const vegID = (selectedVegetableID) ? selectedVegetableID : ''
    setCalendarEntries({...calendarEntries, isLoading:true})
     api
        .get(`/wp-json/mooncal/v1/calendar-entry/vegetable?year=${selectedYear}&vegetableID=${vegID}`)
        .then((response) => {
        setCalendarEntries({entries: response.data.data, total: response.data.pager.total, total_this_page: response.data.pager.total_this_page, max_num_pages: response.data.pager.max_num_pages, isLoading:false})
        })
        .catch((err) => {
            setCalendarEntries({...calendarEntries, isLoading:false})
            console.log(err.message);
        });          

  };


   // Fetch Calendar General Entries 
  useEffect(() => {
    fetchCalendarGeneralEntries()
 }, [selectedYear]);
  
  const fetchCalendarGeneralEntries = async () => {
    setGeneralEntries({...generalEntries, isLoading:true})
     api
        .get(`/wp-json/mooncal/v1/calendar-entry/general?year=${selectedYear}`)
        .then((response) => {
          setGeneralEntries({data: response.data.data, isLoading: false});
        })
        .catch((err) => {
            console.log(err.message);
            setGeneralEntries({...generalEntries, isLoading:false})
        });          
  };


  // Fetch Sowing Date Entries  
  useEffect(() => {
  const fetchSowingDates = async () => {
    setSowingDates({...sowingDates, isLoading: true})
     api
        .get(`/wp-json/mooncal/v1/calendar-entry/sowing?year=${selectedYear}`)
        .then((response) => {
        setSowingDates({data: response.data.data, isLoading: false});
        })
        .catch((err) => {
          console.log(err.message);
          setSowingDates({...sowingDates, isLoading: false})
       });          
  }
  fetchSowingDates()
 }, [selectedYear]);





   // Get Years  

  useEffect(() => {
  const fetchYears = async () => {

  
     api
        .get(`/wp-json/mooncal/v1/years`)
        .then((response) => {
        setYearArr(response.data);
        })
        .catch((err) => {
            console.log(err.message);
        });          
  }
  fetchYears()
 }, []);




   // Find Upcoming Sow Date  
   useEffect(() => {
      const today = new Date()
      today.setHours(0,0,0,0)
      sowingDates.data.some(sd => {
        const entryDate = new Date(sd.date)
        if (entryDate > today && entryDate.getFullYear() === today.getFullYear() ) {
           setNextSowingDate(entryDate)
           return true
        }
        return false;
      })
    }, [sowingDates])


//Handle Change Vegetable Filter






// Handle Clear Filters
    const handleClearFilters = (filter) => {
        setSelectedVegetableID(0)
        setSelectedYear(thisYear)        
        setFilterHasCleared(!filterHasCleared)
    }


// VEGETABLE ENTRIES
  const entries = calendarEntries.entries && calendarEntries.entries.map( entry => 
                  <div key={entry.id} >
                          <div className="text-xs border-t border-black mt-2 pt-2">
                            <div>{new Date(entry.date + 'T00:00:00').toLocaleDateString('en-US', {month: 'numeric', day: 'numeric', year: '2-digit'})} </div>
                            <div className="text-sm font-bold">{entry.title}</div>
                            <div>{entry.description}</div>
                            <div className="hidden">
                              <div>{entry.moon_phase}</div>
                              <div>{entry.zodiac_sign}</div>
                            </div>
                          </div>      
                  </div>

  )


// GENERAL ENTRIES
  const general_entries = generalEntries.data && generalEntries.data.map( entry => 
                  <div key={entry.id} >
                        <div className="text-xs border-t border-black mt-2 pt-2">
                            <div>{new Date(entry.date + 'T00:00:00').toLocaleDateString('en-US', {month: 'numeric', day: 'numeric', year: '2-digit'})} </div>
                            <div className="text-sm font-bold">{entry.title}</div>
                            <div>{entry.description}</div>
                        </div>      
                  </div>

  )




// SOWING DATES
  const sowing_dates = sowingDates.data && sowingDates.data.map( entry => 
      <div key={entry.id} className={`flex justify-between text-xs cursor-arrow hover:bg-black/20 ${ (new Date(entry.date).toLocaleDateString() === nextSowingDate.toLocaleDateString()) ? 'font-bold bg-black/20 -mx-2 px-2 py-1' : '' }`}>
          <div>{entry.title}</div>
          <div className="text-right">{new Date(entry.date + 'T00:00:00').toLocaleDateString('en-US', {weekday: 'short', month: 'numeric', day: 'numeric', year: '2-digit'})}</div>
      </div>      
    )




  return (
    <>  
      {props.vegetables.isLoading || generalEntries.isLoading || calendarEntries.isLoading  ? (  
        <div>
          <div className="w-full h-screen grid place-content-center bg-purple-500">
              <div className="animate-spin w-20 h-20" role="status">
                  <svg dataname="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                    <circle cx="11" cy="11" r="11"/>
                    <path className="fill-orange-400" d="M18,11c0,5.52-3.13,10-7,10,5.52,0,10-4.48,10-10S16.52,1,11,1c3.87,0,7,4.48,7,10Z"/>
                  </svg>               
                  <span className="sr-only">Loading...</span>
              </div>
          </div>

        </div>
      )
      :(
      <>
          <div className="container my-6">
            <h1 className="text-5xl font-bold text-white mb-6">Log: {selectedYear}</h1>
          </div>
          <div className="flex gap-4 mb-4">
            <div className="w-1/3">
              <SelectYear label="Select Year" array={yearArr} filterHasCleared={filterHasCleared} handleChangeSelect={(e) => setSelectedYear(e)}/>
            </div>
            { (selectedYear !== thisYear ) && 
              <button className="text-white font-semibold flex items-center text-xs rounded px-2" onClick={handleClearFilters}><CircleX className="inline-block w-6 h-6" /></button> 
            }
          </div>

          <div className="grid grid-cols-none md:grid-cols-3 gap-4">
            <div className="bg-slate-100 p-2 mb-2 rounded-2xl overflow-auto max-h-[300px] md:max-h-none"> 
                <h2 className="text-lg font-semibold mb-4">Sowing Dates</h2>
                <div className="">
                  {sowing_dates}
                </div>
              </div>

              <div className="bg-slate-100  p-2 mb-2 rounded-2xl overflow-auto max-h-[300px] md:max-h-none">
                <div className="flex justify-between">
                  <h2 className="text-lg font-semibold mb-4">Vegetable Notes</h2>
                  <div className="text-xs">Showing {calendarEntries.total_this_page} of {calendarEntries.total}</div>
                </div>
                <div className="flex gap-4 mb-4">
                  {props.vegetables.length > 0 &&
                    <div className="w-2/3">
                      <SelectVegetables name="selectedVegetableID" label="Filter by Vegetable" array={props.vegetables} filterHasCleared={filterHasCleared} handleChangeSelect={(e) => setSelectedVegetableID(e.id)}/>
                    </div>
                  }
                  { (selectedVegetableID !== 0 || selectedYear !== thisYear ) && 
                    <button className="font-semibold flex items-center text-xs rounded bg-black/10 px-2" onClick={handleClearFilters}><CircleX className="inline-block w-4 h-4" /></button> 
                  }

                </div>
                {entries}
              </div>

              <div className="bg-slate-100 p-2 mb-2 rounded-2xl overflow-auto max-h-[300px] md:max-h-none">
                <h2 className="text-lg font-semibold mb-4">General Notes</h2>
                {general_entries}
              </div>
          </div>
      </>
      )}
    </>
  )
}

export default Log
